export class Asegurado
{
    constructor(
      public dni: string = "",
      public nombre: string = "",
      public tel1: string = "",
      public tel2: string = "",
      public email: string = "",
      public agente: string = "",
      public poliza: string = "",
      public fecSin: string = "",
      public siniestro: string = "",
      public servicio: string = "",
      public dirCliente: string = ""
    ) {}
  }
